import axios from "axios";
import { SERVER } from "./api-urls.js";
export default class CommonService {

  constructor() {

    switch (process.env.REACT_APP_ENV) {
      case "PROD":
        this.baseUrl = SERVER.BASE_URL_PROD;
        break;

      case "STAGE":
        this.baseUrl = SERVER.BASE_URL_STAGE;
        break;

      default:
        this.baseUrl = SERVER.BASE_URL_STAGE;
        break;
    }

    this.apiClient = axios.create({
      baseURL: `${this.baseUrl}/api/`,
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        'Accept': 'application/json',
      }
    });


  }

  httpConnection = async (url, method, body) => {

    switch (method) {
      case "get": {
        const response = await this.httpConnectionGet(url);
        const responseData = response.data ? response.data : "";
        const responseStatus = response.status;

        if (responseStatus === 200 && responseData !== "") {
          return responseData;
        } else {
          return this.errorHandling(response);
        }
      }

      case "post": {
        const response = await this.httpConnectionPost(url, body);
        const responseData = response.data ? response.data : "";
        const responseStatus = response.status;

        if (responseStatus === 200 && responseData !== "") {
          return responseData;
        } else {
          return this.errorHandling(response);
        }
      }

      case "put": {
        const response = await this.httpConnectionPut(url, body);
        const responseData = response.data ? response.data : "";
        const responseStatus = response.status;

        if (responseStatus === 200 && responseData !== "") {
          return responseData;
        } else {
          return this.errorHandling(response);
        }
      }
      case "delete": { 
        const response = await this.httpConnectionDelete(url);
        const responseData = response.data ? response.data : "";
        const responseStatus = response.status;

        if (responseStatus === 200 && responseData !== "") {
          return responseData;
        } else {
          return this.errorHandling(response);
        }
      }
      
        
      case "authLogin": {
        const response = await this.httpConnectionAuthLogin(url, body);
        const responseData = response.data ? response.data : "";
        const responseStatus = response.status;

        if (responseStatus === 200 && responseData !== "") {
          return responseData;
        } else {
          return this.errorHandling(response);
        }
      }

      case "authLoginCheck": {
        const response = await this.httpConnectionAuthLoginCheck(url, body);
        const responseData = response.data ? response.data : "";
        let identifier = "Access denied.";

        if (responseData.includes(identifier)) {
          return this.errorHandling(response);
        } else if (responseData !== "") {
          return responseData;
        } else {
          return this.errorHandling(response);
        }
      }

      case "authLogout": {
        const response = await this.httpConnectionAuthLogout(body);
        const responseData = response.data ? response.data : "";
        const responseStatus = response.status;

        if (responseStatus === 200 && responseData !== "") {
          return responseData;
        } else {
          return this.errorHandling(response);
        }
      }

      case "getNoAPIUrl": {
        const response = await this.httpConnectionGetNoAPIUrl(url);
        const responseData = response.data ? response.data : "";
        const responseStatus = response.status;

        if (responseStatus === 200 && responseData !== "") {
          return responseData;
        } else {
          return this.errorHandling(response);
        }
      }

      case "postNoAPIUrl": {
        const response = await this.httpConnectionPostNoAPIUrl(url, body);
        const responseData = response.data ? response.data : "";
        const responseStatus = response.status;

        if (responseStatus === 200 && responseData !== "") {
          return responseData;
        } else {
          return this.errorHandling(response);
        }
      }


      default:
        return "NOT USING CORRECT METHOD";
    }
  };

  // API calls without /api

  httpConnectionGetNoAPIUrl = async (url) => {
    const apiClient = axios.create({
      baseURL: `${this.baseUrl}`,
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        'Accept': 'application/json',
      }
    });
    try {
      return await apiClient.get(url);
    } catch (error) {
      return error.response;
    }
  };

  httpConnectionPostNoAPIUrl = async (url, body) => {
    const apiClient = axios.create({
      baseURL: `${this.baseUrl}`,
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        'Accept': 'application/json',
      }
    });
    try {
      return await apiClient.post(url, body);
    } catch (error) {
      return error.response;
    }
  };


  // API call with /api

  httpConnectionGet = async (url) => {
    try {
      return await this.apiClient.get(url);
    } catch (error) {
      return error.response;
    }
  };

  httpConnectionPost = async (url, body) => {
    const apiClient = axios.create({
      baseURL: `${this.baseUrl}/api/`,
      withCredentials: true,
      headers: {
        "Content-Type": (url === "Tire/CreateImages/") ? "multipart/form-data" :"application/json",
        'Accept': 'application/json',
      }
    });

    try {
      return await apiClient.post(url, body);
    } catch (error) {
      return error.response;
    }
  };
  httpConnectionPut = async (url, body) => {
    try {
      return await this.apiClient.put(url, body);
    } catch (error) {
      return error.response;
    }
  };
  httpConnectionDelete = async (url) => {
    try {
      return await this.apiClient.delete(url);
    } catch (error) {
      return error.response;
    }
  };


  // login exclusive API connection

  httpConnectionAuthLogin = async (url, body) => {
    const AuthApiClient = axios.create({
      baseURL: this.baseUrl,
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        'Accept': 'application/json',
      }
    });
    try {
      return await AuthApiClient.post(url, body);
    } catch (error) {
      return error.response;
    }
  };

  httpConnectionAuthLoginCheck = async (url, body) => {
    const AuthApiClient = axios.create({
      baseURL: this.baseUrl,
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        'Accept': 'application/json',
      }
    });
    try {
      return await AuthApiClient.get(url, body);
    } catch (error) {
      return error.response;
    }
  };

  httpConnectionAuthLogout = async (body) => {
    const AuthApiClient = axios.create({
      baseURL: this.baseUrl,
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        'Accept': 'application/json',
      }
    });
    try {
      return await AuthApiClient.post(`/Auth/Logout`,body);
    } catch (error) {
      return error.response;
    }
  };

  errorHandling = (response) => {

    if (response.status === 401) {
      sessionStorage.setItem("isAuthenticated", false);
      if (sessionStorage.getItem("hasLoggedIn") === 'true') {
        sessionStorage.setItem("hasLoggedIn", false);
        alert("Due to inactivity or authentication protocols, your session has expired. For your protection, please log in again to continue using our services.");
        let currentUrl = window.location.href;
        let segments = currentUrl.split('/');
        let lastSegment = segments.pop();

        if (lastSegment !== 'login') {
          segments.push('login');
          let newUrl = segments.join('/');
          window.location.href = newUrl;
        }
      }
    } 
    else if (response.status === 404) {
        if (response?.request?.responseURL.includes(`${this.baseUrl}/Account/Login`)) {
          alert (`It looks like the page you’re trying to reach doesn’t exist. This might be due to a broken link, or the page may have been moved or deleted. Application will now reload.`);
            window.location.reload();
        }
    } else if (response.status === 500) {
      if (!(response?.request?.responseURL.includes(`${this.baseUrl}/api/Location/GetLocationById/0`))) {
      alert (`Encountered an internal server error, Please send an email for the concern. The application will now refresh.`);
      window.location.reload();
      }
    }
    return response;
  };
}
